import * as Ids from '../ids';
import request from '../axiosWrapper';
import getAppInfo from './getAppInfo';

enum BUSINESS_DATA_TYPE {
    ORDER_STAT = 'order_stat',
    PRINTER_CONFIG = 'printer_config',
    IM = 'im',
    IM_SG = 'im_sg',
    NEW_SHELL = 'new_shell',
}

const wmPoiId = Ids.getWmPoiId();
const acctId = Ids.getAcctId();

const { appCode, appFullVersion, systemRelease } = getAppInfo();

/** 上报业务数据 */
const reportBusinessData = async (type: BUSINESS_DATA_TYPE, data: any) => {
    const reportData: any = {
        event: 'BusinessData',
        logLevel: 'info',
        time: new Date().getTime(),
        acctId,
        wmPoiId,
        data: { type, data },
    };

    if (appCode !== 0) {
        reportData.appCode = appCode;
    }

    if (appFullVersion !== '') {
        reportData.appVer = appFullVersion;
    }

    if (systemRelease) {
        reportData.sysVer = systemRelease;
    }

    return request.postAsFormSubmit('/v2/pc/report/log', {
        data: JSON.stringify([reportData]),
    });
};

export { BUSINESS_DATA_TYPE, reportBusinessData };
